import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@ipc/ipc-components';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import OperatorSelectionContainer from './OperatorSelectionContainer';
import { onLeftPostalOperatorChecked, onRightPostalOperatorChecked } from '../redux/actions/OperatorImpcActions';
import {
  getLeftCheckedPostalOperators,
  getRightCheckedPostalOperators,
} from '../../../user/redux/selectors/UserDataSelectors';

class OperatorSelectionCriteriaContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: props.open,
    };
  }

  togglePanel = () => {
    this.setState((prevState) => ({ open: !prevState.open }));
  };

  isApplyEnabled = () => {
    if (this.props.leftCheckedPostalOperators.length === 0) {
      return false;
    }
    if (this.props.rightTree) {
      if (this.props.rightCheckedPostalOperators.length === 0) {
        return false;
      }
    }
    return true;
  }

  apply = () => {
    this.props.onApply();
    this.togglePanel();
  }

  render() {
    return (
      <div className="selection-criteria-container">
        <h3 className="title-div">{this.props.title}</h3>
        <div className="operator-selector-wrapper">
          <div className="operators">
            <div className="operators-selection-panel">
              <div className="operator">
                <div className="expand-div-button">
                  <h6>
                    SELECTION CRITERIA
                  </h6>
                  <div onClick={(e) => this.togglePanel(e)} className="expand-button">
                    <FontAwesomeIcon icon={this.state.open ? 'angle-down' : 'angle-right'} className="expand-icon" />
                  </div>
                </div>
                <div className={`checkboxtree-div ${this.state.open}`}>
                  <div>
                    <OperatorSelectionContainer
                      {...this.props}
                    />
                  </div>
                  <div>
                    <Button
                      disabled={!this.isApplyEnabled()}
                      className={`apply-div-${!this.isApplyEnabled()}`}
                      onClick={this.apply}
                    >
                      APPLY
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

OperatorSelectionCriteriaContainer.propTypes = {
  title: PropTypes.string,
  open: PropTypes.bool,
  onApply: PropTypes.func,
  leftCheckedPostalOperators: PropTypes.arrayOf(PropTypes.string),
  rightCheckedPostalOperators: PropTypes.arrayOf(PropTypes.string),
  rightTree: PropTypes.shape(PropTypes.object),
};

OperatorSelectionCriteriaContainer.defaultProps = {
  open: false,
};

function mapStateToProps(state) {
  return {
    leftCheckedPostalOperators: getLeftCheckedPostalOperators(state),
    rightCheckedPostalOperators: getRightCheckedPostalOperators(state),
  };
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  onLeftPostalOperatorChecked,
  onRightPostalOperatorChecked,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(OperatorSelectionCriteriaContainer);
